import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Picture, User } from '@app/entity';

@Component({
  selector: 'app-user-photo-square-cropper',
  templateUrl: './user-photo-square-cropper.component.html',
  styleUrls: ['./user-photo-square-cropper.component.scss']
})
export class UserPhotoSquareCropperComponent implements OnInit {
  @Input() currentUser: User;
  @Input() isUploadingPhoto = false;
  @Input() disableLoad = false;
  @Input() hasPhoto = false;
  @Output() isUploadingPhotoChange = new EventEmitter<boolean>();
  @Output() changePicture = new EventEmitter<Picture>();
  @Output() onChangeLoader = new EventEmitter();

  message = 'Вы можете загрузить изображение в формате JPG, GIF или PNG. ' +
            'Минимальный размер 270x200. Cоотношение сторон 4:3.';

  constructor() { }

  ngOnInit() {
  }

  changeLoader(loader) {
    this.onChangeLoader.emit(loader);
  }
}



// WEBPACK FOOTER //
// ./src/app/accounts/user-photo-square-cropper/user-photo-square-cropper.component.ts